import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext.jsx';
import { landingRouteForRole } from '../pages/sign-in/roleLanding.js';
import { OPERATOR_HOME, accessRole, canAccessSlug, isOperatorRole } from '../config/routeAccess.js';

/**
 * Root route ("/"). Anonymous visitors go to sign-in; signed-in users go to their
 * role's landing page, or to /403 when the role has no page it may open. The Xamun Operator goes to the console.
 */
export default function HomeRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/sign-in" replace />;
  if (isOperatorRole(user.role)) return <Navigate to={OPERATOR_HOME} replace />;
  const role = accessRole(user);
  const landing = landingRouteForRole(role);
  return <Navigate to={canAccessSlug(role, landing.slice(1)) ? landing : '/403'} replace />;
}
